module.exports = __webpack_public_path__ + "img/设置.4f25dcb9.svg";